import { render, staticRenderFns } from "./Sutherapy.vue?vue&type=template&id=84d571f2&scoped=true&"
import script from "./Sutherapy.vue?vue&type=script&lang=js&"
export * from "./Sutherapy.vue?vue&type=script&lang=js&"
import style0 from "./Sutherapy.vue?vue&type=style&index=0&id=84d571f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d571f2",
  null
  
)

/* custom blocks */
import block0 from "./Sutherapy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports